import { render } from "./enrollment.vue?vue&type=template&id=00a5b4f9&scoped=true"
import script from "./enrollment.vue?vue&type=script&lang=js"
export * from "./enrollment.vue?vue&type=script&lang=js"

import "./enrollment.vue?vue&type=style&index=0&id=00a5b4f9&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a5b4f9"]])

export default __exports__